import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DataTableModule } from "angular-6-datatable-cc";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxKeyboardEventsModule } from 'ngx-keyboard-events';
import { SharedModuleModule } from './shared-module/shared-module.module';
import { DataTable } from 'angular-6-datatable-cc/src/DataTable';
import { HttpsInterceptor } from './https-interceptor';



@NgModule({
    declarations: [
        AppComponent


        // DataTable
    ],
    imports: [
        BrowserModule,
        SharedModuleModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,

        NgxBarcodeModule,
        NgxKeyboardEventsModule,
        DataTableModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpsInterceptor, multi: true } // Register HTTPS Interceptor

    ],
    bootstrap: [AppComponent]
})

export class AppModule { }
